import React from 'react'
import TreeFilter from 'components/TreeSelectFilter'


const CollegeLocationFilter = ({ filterOptions, filterValues,handleFilterSearch,handleFilterChange}) => {
  // Convert the API format to the format expected by TreeSelect component

  return (
    <>
    <div style={{ display:'flex' , rowGap: '0px !important' }}>
    <TreeFilter
    span={12}
     width="95%"
     label="Select State"
     placeholder="Search of the state"
     treeData={filterOptions?.collegeStateList}
     value={filterValues?.selectedCollegeStates}
     onChange={handleFilterChange}
     onSearch={handleFilterSearch} 
     valueKey='selectedCollegeStates'
    />
     <TreeFilter
     span={11}
     width="100%"
     label="Select City"
     placeholder="Search of the city"
     treeData={filterOptions?.collegeCityList}
     value={filterValues?.selectedCollegeCities}
     onChange={handleFilterChange}
     onSearch={handleFilterSearch}
     valueKey='selectedCollegeCities'
    />
 </div>
 <div style={{ display:'flex', marginTop:'10px', rowGap: '0px !important' }}>
 <TreeFilter
     label="College Name"
     placeholder="Select College Name"
     treeData={filterOptions?.collegeList}
     value={filterValues?.selectedColleges}
     onChange={handleFilterChange}
     onSearch={handleFilterSearch}
     valueKey='selectedColleges'    
    />
 </div>
   </>
  )
}

export default CollegeLocationFilter
